/**
 * Cleans a URL by extracting the pathname and removing /websites/{name} prefix if present
 * @param {string} urlString - The URL string to clean (full URL or pathname)
 * @returns {string} The cleaned pathname with query string (e.g., '/stock/vases/?sort=high_to_low_price&page=1')
 */
function cleanUrl(urlString) {
  if (!urlString) {
    return "";
  }

  try {
    let pathname, search;

    // Check if it's a full URL or just a pathname
    if (urlString.startsWith("http://") || urlString.startsWith("https://")) {
      const url = new URL(urlString);
      pathname = url.pathname;
      search = url.search;
    } else {
      // It's just a pathname (possibly with search params)
      const parts = urlString.split("?");
      pathname = parts[0];
      search = parts[1] ? "?" + parts[1] : "";
    }

    // Remove /websites/{name} prefix if present
    const websitePattern = /^\/websites\/[^\/]+/;
    pathname = pathname.replace(websitePattern, "");

    // Ensure pathname starts with /
    if (!pathname.startsWith("/")) {
      pathname = "/" + pathname;
    }

    // If pathname is just "/", return empty string (or empty with search params)
    if (pathname === "/") {
      return search || "";
    }

    return pathname + search;
  } catch (error) {
    console.error("Error cleaning URL:", error);
    return "";
  }
}

// Make available globally for use in inline scripts
if (typeof window !== "undefined") {
  window.cleanUrl = cleanUrl;
}
